export default "__VITE_ASSET__CNASGB6x__"